import { Status } from '../http';
import { CustomTokenAPIResponse } from './types';

export const toCustomTokenAPIResponse = (res): CustomTokenAPIResponse => ({
  status: Status.Success,
  data: res,
});
